import { useChatbarNotificationStore } from "../../Stores/ChatbarNotification";
import { useConfigStore } from "../../Stores/Config";

export default function ChatbarPill({ onOpen }: { onOpen: (shareToken?: string) => void }) {
  const pill = useChatbarNotificationStore((s) => s.pill);
  const botName = useConfigStore((s) => s.getBotName());
  if (!pill) return null;
  return (
    <button className="chatbar-pill" onClick={() => onOpen(pill.shareToken ?? undefined)}>
      <span className="chatbar-pill-sender">{pill.sender || botName}</span>
      <span className="chatbar-pill-text">{pill.text}</span>
    </button>
  );
}
